import { LogisticsFilterType } from '~/client/src/shared/enums/LogisticsFilterType'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import BaseLogisticsFilterStore from '~/client/src/shared/stores/BaseLogisticsFilter.store'
import BaseLogisticsList from '~/client/src/shared/stores/BaseLogisticsLists.store'
import InitialState from '~/client/src/shared/stores/InitialState'
import UIFilterInfo from '~/client/src/shared/stores/substates/UIFilterInfo'
import BaseLogisticsMapStore from '~/client/src/shared/stores/ui/BaseLogisticsMap.store'
import { IOption } from '~/client/src/shared/stores/ui/SuperFilter.store'

type ISourceMap = { [optionId: string]: string[] }

export default class DesktopLogisticsFilterStore extends BaseLogisticsFilterStore {
  public constructor(
    type: LogisticsFilterType,
    state: InitialState,
    getSourceMap: () => ISourceMap,
    logisticsInstanceStore: BaseLogisticsList | BaseLogisticsMapStore,
    onShowChanged: (isShown: boolean, type: string) => void,
    fieldsMap: { [filterType: string]: UIFilterInfo },
    getTypeCaption: (type: string) => string,
    getOptionName: (optionId: string, filterType: string) => string,
    getCroppedAmount: (option: IOption) => number,
    getTotalAmount: (option: IOption) => number,
    onClickHandler?: () => void,
  ) {
    super(
      type,
      state,
      getSourceMap,
      logisticsInstanceStore,
      onShowChanged,
      fieldsMap,
      getTypeCaption,
      getOptionName,
      onClickHandler,
    )

    this.getCroppedAmount = getCroppedAmount
    this.getTotalAmount = getTotalAmount
  }

  public get applyButtonLabel() {
    if (!this.selectedOptions.size) {
      return Localization.translator.disableFilter
    }

    return Localization.translator.apply
  }
}
